<template>
  <div class="container-fluid pb-2">
    <ValidationObserver ref="form">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-2">
          <label class="font-weight-normal mb-1">Fecha:</label>
          <ValidationProvider v-slot="{ errors }" name="date" rules="required">
            <CustomDatePicker
              v-model="deliveredDate"
              :max-date="maxDate"
              :error="errors[0]"
              custom-error-msg="La fecha es requerida."
              :class-container="isMobile ? 'w-100' : ''"
              required
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-10 mt-auto">
          <div :class="['d-flex justify-content-end', { 'pt-3': isMobile }]">
            <ActionButton
              :class="['mr-2 btn-transparent', { 'w-100': isMobile }]"
              variant="outline-danger"
              text="Cancelar"
              i="fas fa-times-circle mx-auto"
              @click="cancel"
            />
            <ActionButton
              :class="{ 'w-100': isMobile }"
              variant="success"
              text="Guardar"
              i="fas fa-save mx-auto"
              @click="save"
            />
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import { determineBook } from '@/modules/books-requests/api';
import {
  studentBookStatus,
  studentBookStatusString,
} from '@/utils/constants/book/studentBookStatus';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'DetermineBookDate',
  mixins: [alert],
  components: {
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    CustomDatePicker,
  },
  data() {
    return {
      deliveredDate: null,
      maxDate: new Date(),
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel-determine-book');
    },
    refreshSearch() {
      this.$emit('success-determine-book');
      this.cancel();
    },
    async save() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        const book = {
          bookId: this.value.bookId,
          academicYearId: this.value.academicYearId,
          studentSieId: this.value.studentSieId,
          deliveredDate: this.deliveredDate,
          targetStatusId: studentBookStatus.Entregado,
        };

        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea poder cambiar el estatus de ${this.value.status} a ${studentBookStatusString.Entregado}?`
        );
        if (answer) {
          determineBook(book)
            .then((res) => {
              if (res.status == 200) {
                this.ShowToast(
                  'Proceso exitoso.',
                  'Los datos fueron guardados exitosamente.',
                  'success'
                );
                this.refreshSearch();
              }
            })
            .catch((err) => {
              if (err && err.response && err.response.data) {
                this.ShowToast('Error', err.response.data.message, 'error');
              } else {
                this.ShowToast('Error', err.message, 'error');
              }
            });
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .student-search-alert-error {
  height: 0;
}
</style>
